import { Component, ojs, app, payload, component } from "modular-openscriptjs";
import DOMPurify from "dompurify";
import { _UNIQUE_ID_ } from "../../declarations";
import { either, eParse, isMobile } from "../../helpers";
import { dom } from "../../fotastart";
import MentionSearchForm from "../Forms/MentionSearchForm";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

ojs(MentionSearchForm);

export default class TextArea extends Component {
	timeoutIds = {};

	render(...args) {
		let id = `textarea-${_UNIQUE_ID_}`;

		return h.$(
			h.div(
				{
					contenteditable: true,
					methods: {
						value: function () {
							return DOMPurify.sanitize(this.innerHTML, {
								ALLOWED_TAGS: [
									"b",
									"i",
									"u",
									"div",
									"span",
									"br",
									"p",
									"ojs-mention",
								],
								ALLOWED_ATTR: ["style", "class"],
							});
						},
					},

					ta_hook: id,
				},
				either(
					isMobile(),
					{
						listeners: {
							input: function (event) {
								let input = this.textContent;

								if (!input.length || /^\s+$/.test(input)) {
									dom.empty(this);
								}

								clearTimeout(
									component("TextArea").timeoutIds[id]
								);

								component("TextArea").timeoutIds[id] =
									setTimeout(() => {
										component("TextArea").handleHashtags(
											this,
											event
										);
										component("TextArea").handleMentions(
											this,
											event
										);
									}, 200);
							},
						},
					},
					{
						listeners: {
							keydown: function (event) {
								let input = this.textContent;

								if (!input.length || /^\s+$/.test(input)) {
									dom.empty(this);
								}

								clearTimeout(
									component("TextArea").timeoutIds[id]
								);

								component("TextArea").timeoutIds[id] =
									setTimeout(() => {
										component("TextArea").handleHashtags(
											this,
											event
										);
										component("TextArea").handleMentions(
											this,
											event
										);
									}, 200);
							},
						},
					}
				),
				...args
			)
		);
	}

	handleMentions(elem, event) {
		if (elem.getAttribute("notice-mentions") != "true") return;

		let char = event.key;

		if (char == "Unidentified" || !char) {
			char = elem.textContent?.slice(-1);
		}

		if (char != "@") return;

		broker.send(
			$e.mention.needs.search,
			payload(
				{},
				{
					from: "text-area",
					hook: elem.getAttribute("ta-hook"),
					type: "@",
				}
			)
		);
	}

	handleHashtags(elem, event) {
		if (elem.getAttribute("notice-hashtags") != "true") return;

		let char = event.key;

		if (char == "Unidentified" || !char) {
			char = elem.textContent?.slice(-1);
		}

		if (char != "#") return;

		broker.send(
			$e.mention.needs.search,
			payload(
				{},
				{
					from: "text-area",
					hook: elem.getAttribute("ta-hook"),
					type: "#",
				}
			)
		);
	}

	processMention(ed, event) {
		let { value } = eParse(ed).message;
		let { from, hook, type } = eParse(ed).meta;

		if (from != "text-area") return;

		let elem = dom.get(`[ta-hook="${hook}"]`);

		elem.focus();

		const selection = window.getSelection();
		const range = selection.getRangeAt(0);
		const content = elem.textContent;

		const regex = new RegExp(`${type}([a-z0-9A-Z-_]+)?(<\/.+>)?$`, "g");
		const match = regex.exec(content);

		if (match) {
			const { node: textNode, count } = this.findChildNodeAtIndex(
				elem,
				match.index
			);
			const mentionText = match[0];
			let startOffset = match.index;

			if (match.index > count) {
				startOffset = match.index - count;
			}
			if (textNode.textContent.length < startOffset) {
				startOffset = 0;
			}

			const endOffset = startOffset + mentionText.length;

			range.setStart(textNode, startOffset);
			range.setEnd(textNode, endOffset);
			range.deleteContents();

			const mentionTag = h.Mention(`${type}${value}`);

			const emptySpan = document.createElement("span");
			emptySpan.innerHTML = "&#8203;&nbsp;";

			const fragment = document.createDocumentFragment();
			fragment.appendChild(mentionTag);
			fragment.appendChild(emptySpan);
			range.insertNode(fragment);

			range.setStart(emptySpan, 1);
			range.setEnd(emptySpan, 1);

			selection.removeAllRanges();
			selection.addRange(range);
		}

		const ev = new CustomEvent("mentionRendered", {
			detail: { content: elem.methods().value() },
		});
		elem.dispatchEvent(ev);
	}

	$$mention = {
		has: {
			value: (ed, event) => this.processMention(ed, event),
		},
	};

	findChildNodeAtIndex(parentElement, index) {
		let charCount = 0;

		function findNode(node) {
			if (node.nodeType === Node.TEXT_NODE) {
				const length = node.textContent.length;
				if (charCount + length > index) {
					return { node, count: charCount };
				} else {
					charCount += length;
				}
			} else if (node.nodeType === Node.ELEMENT_NODE) {
				for (let i = 0; i < node.childNodes.length; i++) {
					const result = findNode(node.childNodes[i]);
					if (result) {
						return result;
					}
				}
			}
			return null;
		}

		return findNode(parentElement);
	}
}
